import styled from "styled-components";
import { FlagContainer } from "../InmateFlag/styles";
import { CONSTANT } from "@/util/ant_var";
import { Row } from "antd";

export const FlagSection = styled.section`
  margin-bottom: 10px;
  padding: 0 10px;
`;

export const FlagHeader = styled(FlagContainer)`
  width: 100%;
  justify-content: space-between;
  gap: 10px;
  padding: 0 10px;
  min-height:45px;
  align-items: center;
  color:var(--text-color-white);
  ${({ enabled }) =>
    !enabled && { background: `${CONSTANT.BUTTON_SECONDARY_BG} !important`, boxShadow: "unset !important" }}
`;

export const FlagBody = styled.div`
  margin: 10px 0 0px 10px;
color: ${CONSTANT.BLACK};
  .date-range {
    display: flex;
    margin-bottom: 10px;
  }
`;
export const FlagFooter = styled.div`
  display: flex;
  margin: 10px 0 0 10px;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
`;
export const StyledFlagFooter = styled(Row)`
border-top:1px solid var(--grey-color-light);
padding-top:10px;
`